/** Strings owned by `src/features/communications/` — PLAN-FASE3.md WP-02's
 * `/communications` composer + send log, under the Content pill. */
export const communications = {
  page: {
    title: 'Communication',
    lead: 'Compose and schedule notifications for {{company}}.',
    noScope: 'Select a company to see its communications.',
    forbidden: 'You are not allowed to see this company’s communications.',
  },
  composer: {
    title: 'New notification',
    titleField: 'Title',
    message: 'Message',
    category: 'Category',
    audience: 'Target audience',
    date: 'Date',
    time: 'Time',
    callToAction: 'Call to action',
    quietHours: 'Respect quiet hours',
    quietHoursHint: 'Delay delivery outside 08:00–20:00.',
    submit: 'Save as concept',
    schedule: 'Schedule',
    send: 'Send now',
  },
  categories: {
    algemeen: 'General',
    veiligheid: 'Safety',
    evenement: 'Event',
    vitaliteit: 'Vitality',
    hr: 'HR',
  },
  audiences: {
    iedereen: 'Everyone',
    management: 'Management',
    per_afdeling: 'Per department',
    per_locatie: 'Per location',
  },
  status: {
    concept: 'Concept',
    ingepland: 'Scheduled',
    verzonden: 'Sent',
  },
  log: {
    title: 'Send log',
    empty: 'No communications yet.',
    columns: {
      message: 'Message',
      category: 'Category',
      reach: 'Reach',
      openRate: 'Open rate',
      status: 'Status',
    },
  },
  actions: {
    new: 'New notification',
    cancel: 'Cancel',
    markScheduled: 'Mark as scheduled',
    markSent: 'Mark as sent',
  },
} as const;
